import { render, staticRenderFns } from "./APIHomepage_more.vue?vue&type=template&id=4d8ac5e2&scoped=true&"
import script from "./APIHomepage_more.vue?vue&type=script&lang=js&"
export * from "./APIHomepage_more.vue?vue&type=script&lang=js&"
import style0 from "./APIHomepage_more.vue?vue&type=style&index=0&id=4d8ac5e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8ac5e2",
  null
  
)

export default component.exports